import { motion } from "framer-motion";
import { Eyebrow, MaskLines } from "./Reveal";

export const PageHeader = ({ eyebrow, lines, intro, children, testid }) => (
  <section className="relative pt-36 sm:pt-44 pb-16 sm:pb-24 overflow-hidden" data-testid={testid}>
    <div className="absolute inset-0 grid-lines opacity-60 [mask-image:radial-gradient(ellipse_at_top_left,black,transparent_70%)]" />
    <div className="absolute -top-40 -right-40 w-[520px] h-[520px] rounded-full bg-[#0066ff]/15 blur-[120px]" />
    <div className="relative max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12">
      <Eyebrow className="mb-8">{eyebrow}</Eyebrow>
      <h1 className="font-display font-extrabold uppercase tracking-tight leading-[0.92] text-[clamp(1.7rem,8vw,7.5rem)] [overflow-wrap:anywhere]">
        <MaskLines lines={lines} ready lineClass="[&:nth-child(1)]:text-white" delay={0.1} />
      </h1>
      {intro ? (
        <motion.p
          className="mt-10 max-w-2xl text-base sm:text-lg text-slate-300 leading-relaxed"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.9 }}
        >
          {intro}
        </motion.p>
      ) : null}
      {children}
    </div>
  </section>
);

export const Section = ({ children, className = "", id, testid }) => (
  <section id={id} className={`relative py-20 lg:py-32 ${className}`} data-testid={testid}>
    <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12">{children}</div>
  </section>
);
